import { useContext } from 'react';
import { useSelector } from 'react-redux';
import invariant from 'invariant';
import DataPathContext from '../components/DataPathContext';
export const useRowModel = (dataPathCtx)=>{
    const ctx = useContext(DataPathContext);
    const dataPath = dataPathCtx || ctx;
    return useSelector((state)=>{
        let initialRow = state.data.present;
        if (dataPath.detachedId) {
            invariant(state.detachedRow, `detachedRow is missing in the redux store. Make sure you are using detachedRowReducer, e.g.

import { configureStore } from '@reduxjs/toolkit';
import { detachedRowReducer } from '@cancercentrum/rcc-react';

const store = configureStore({
    reducer:
        detachedRow: detachedRowReducer,
    },
});
`);
            initialRow = state.detachedRow[dataPath.detachedId]?.present;
            if (!initialRow) {
                throw 'Invalid detachedId passed to useRowModel';
            }
        }
        const res = dataPath.path.reduce((r, p)=>{
            if (!r) {
                throw 'Invalid path passed to useRowModel';
            }
            const rows = r.getSubTableRows(p.tableName);
            return rows.find((x)=>x.getId() === p.rowId);
        }, initialRow);
        if (!res) {
            throw 'Invalid path passed to useRowModel';
        }
        return res;
    });
};
